import React from 'react';
import PriceWarning from './components/PriceWarning';
import PriceComparer from './components/PriceComparer';
import PriceTimer from './components/PriceTimer';
import { ACTUALIZATION_TIMEOUT } from '../../store/constants/actualization';

type Props = {
  className?: string;
  priceChanged: boolean;
  oldPrice: number | null;
  currentPrice?: number;
  lastUpdated: number;
  fetching: boolean;
  isMobile: boolean;
};

const PriceChecker = (props: Props) => {
  const {
    className = '',
    priceChanged,
    oldPrice,
    currentPrice,
    lastUpdated,
    fetching,
    isMobile,
  } = props;

  if (!currentPrice || !oldPrice) return null;

  return (
    <div className={className}>
      {priceChanged && (
        <>
          <PriceWarning
            oldPrice={oldPrice}
            currentPrice={currentPrice}
            isMobile={isMobile}
          />
          <PriceComparer oldPrice={oldPrice} currentPrice={currentPrice} />
        </>
      )}
      <PriceTimer
        fetching={fetching}
        timeout={ACTUALIZATION_TIMEOUT}
        lastUpdated={lastUpdated}
      />
    </div>
  );
};

export default PriceChecker;
